'use client'
import {CardProps, DecoratedCardProps} from "../Card/types";
import {CardContainer, CardDecoration} from "../Card/styles";
import React, {useRef} from "react";
import {Card} from "../Card/index";
import {Parallax,  useParallax} from "../Card/animations";





export const ParallaxCard = ({
                               decoration,
                               decorationPosition,
                               decorationColor,
                               children,
                               style,
                               className,
                               ...props
                             }: CardProps) => {
  const ref = useParallax();
  const decorated = decoration || decorationPosition || decorationColor;
  return (
    <CardContainer  {...{style, className}} decorated={decorated} >
      {decorated && <CardDecoration  position={decorationPosition || 'left'} style={{backgroundColor: decorationColor || '#f7f7f7'}}/>}
      <Card ref={ref} {...props} >{children}</Card>
    </CardContainer>
  );
};


